<template>
  <div>
    <div class="card">
      <div class="card-header">
        <a-form :form="form" layout="inline">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-xl-6">
                  <div class="row">
                    <div class="col-md-8 offset-md-4">
                      <a-form-item
                        :label-col="{
                          xs: { span: 24 },
                          sm: { span: 8 },
                        }"
                        :wrapper-col="{
                          xs: { span: 24 },
                          sm: { span: 16 },
                        }"
                        style="width: 380px"
                        :label="$t('Fiscal Year (B.E.)')"
                      >
                        <a-input
                          :placeholder="$t('Fiscal Year (B.E.)')"
                          v-decorator="[
                            'fiscal_year',
                            {
                              initialValue: '',
                              rules: [
                                {
                                  required: false,
                                  message: '',
                                },
                              ],
                            },
                          ]"
                          @pressEnter="handleFilter"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-8 offset-md-4">
                      <a-form-item
                        :label-col="{
                          xs: { span: 24 },
                          sm: { span: 8 },
                        }"
                        :wrapper-col="{
                          xs: { span: 24 },
                          sm: { span: 16 },
                        }"
                        style="width: 380px"
                        :label="$t('Start Date of Project')"
                      >
                        <a-input
                          :placeholder="$t('Start Date of Project')"
                          v-decorator="[
                            'start_date',
                            {
                              initialValue: '',
                              rules: [
                                {
                                  required: false,
                                  message: '',
                                },
                              ],
                            },
                          ]"
                          @pressEnter="handleFilter"
                        />
                      </a-form-item>
                    </div>
                    <div class="col-md-8 offset-md-4">
                      <a-form-item
                        :label-col="{
                          xs: { span: 24 },
                          sm: { span: 8 },
                        }"
                        :wrapper-col="{
                          xs: { span: 24 },
                          sm: { span: 16 },
                        }"
                        style="width: 380px"
                        :label="$t('Keyword')"
                      >
                        <a-input
                          :placeholder="$t('Keyword')"
                          v-decorator="[
                            'keyword',
                            {
                              initialValue: '',
                              rules: [
                                {
                                  required: false,
                                  message: '',
                                },
                              ],
                            },
                          ]"
                          @pressEnter="handleFilter"
                        />
                      </a-form-item>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="col-xl-12">
                    <a-form-item
                      :label-col="{
                        xs: { span: 24 },
                        sm: { span: 8 },
                      }"
                      :wrapper-col="{
                        xs: { span: 24 },
                        sm: { span: 16 },
                      }"
                      style="width: 380px"
                      :label="$t('Work Plan')"
                    >
                      <a-input
                        :placeholder="$t('Work Plan')"
                        v-decorator="[
                          'work_plan',
                          {
                            initialValue: '',
                            rules: [
                              {
                                required: false,
                                message: '',
                              },
                            ],
                          },
                        ]"
                        @pressEnter="handleFilter"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-10">
                    <a-form-item
                      :label-col="{
                        xs: { span: 24 },
                        sm: { span: 8 },
                      }"
                      :wrapper-col="{
                        xs: { span: 24 },
                        sm: { span: 16 },
                      }"
                      style="width: 380px"
                      :label="$t('End Date of Project')"
                    >
                      <a-input
                        :placeholder="$t('End Date of Project')"
                        v-decorator="[
                          'cardId',
                          {
                            initialValue: '',
                            rules: [
                              {
                                required: false,
                                message: '',
                              },
                            ],
                          },
                        ]"
                        @pressEnter="handleFilter"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-10 offset-md-2">
                    <a-button
                      type="button"
                      class="btn btn-primary mt-1 mb-1"
                      @click="handleFilter"
                      :loading="searching"
                    >
                      {{ $t('Search') }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-form>
        <div class="text-right">
          <a-button
            type="button"
            class="btn btn-outline-primary mt-1 mb-1"
          >
             {{ $t('Contract Management / Tracking Report') }}
          </a-button>
        </div>
      </div>
      <div class="card-body">
        <a-table
          :columns="columns"
          :dataSource="data"
          :pagination="false"
          :locale="table_locale"
        >
          <a
            slot="name"
            slot-scope="text, row"
            href="javascript: void(0);"
            class="btn btn-sm btn-light"
            @click="userInfo(row.uuid)"
          >
            {{ text }}
          </a>
        </a-table>
        <div class="col-md-10" style="padding: 1.33rem 0">
          <a-pagination
            v-model="current_page"
            :total="last_page"
            @change="handleFilter"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* import _ from 'lodash'; */
import data from './data.json'
export default {
  data: function () {
    const columns = [
      {
        title: '#',
        dataIndex: 'key',
        scopedSlots: { customRender: 'key' },
      },
      {
        title: this.$t('Project Name'),
        dataIndex: 'project_name',
        scopedSlots: { customRender: 'project_name' },
        sorter: (a, b) => a.project_name - b.project_name,
      },
      {
        title: this.$t('Status'),
        dataIndex: 'status',
      },
      {
        title: this.$t('Contact No'),
        dataIndex: 'no',
      },
      {
        title: this.$t('End Date'),
        dataIndex: 'end_date',
      },
      {
        title: this.$t('Budget (Plan)'),
        dataIndex: 'budget_plan',
      },
      {
        title: this.$t('Budget (Contact)'),
        dataIndex: 'budget_contact',
      },
      {
        title: this.$t('Disbursement'),
        dataIndex: 'disbursement',
      },
      {
        title: this.$t('Vendor'),
        dataIndex: 'vendor_name',
        scopedSlots: { customRender: 'vendor_name' },
        sorter: (a, b) => a.vendor_name - b.vendor_name,
      },
      {
        title: this.$t('Responsible Name'),
        dataIndex: 'responsible_name',
        scopedSlots: { customRender: 'responsible_name' },
        sorter: (a, b) => a.responsible_name - b.responsible_name,
      },
    ];
    return {
      form: this.$form.createForm(this),
      searchText: '',
      searching: false,
      current_page: 1,
      last_page: 1,
      columns,
      data,
      table_locale: {
        filterConfirm: this.$t('Ok'),
        filterReset: this.$t('Reset'),
        emptyText: this.$t('No Data'),
      },
    };
  },
  methods: {
    handleSearch(selectedKeys, confirm) {
      /* confirm();
      this.searchText = selectedKeys[0]; */
    },
    handleReset(clearFilters) {
      /* clearFilters();
      this.searchText = ''; */
    },
    handleFilter(current_page = null) {
      /* if (typeof current_page != 'number') current_page = this.current_page;
      this.form.validateFields((err, values) => {
        if (!err) {
          this.searching = true;
          this.$store.dispatch('user/POST', {
            payload: {
              path: '/api/users/findUsers',
              data: {
                pageNo: current_page,
                itemPerPage: 20,
                ...values,
              },
              callback: (res) => {
                if (res && res.data) {
                  if (res.current_page) this.current_page = res.current_page;
                  if (res.last_page) this.last_page = res.last_page * 10;
                  if (_.isArray(res.data.users)) {
                    this.data = _.filter(
                      res.data.users,
                      (v, k) =>
                        (v.row_number =
                          (this.current_page > 1
                            ? 20 * (this.current_page - 1)
                            : 0) +
                          k +
                          1)
                    );
                  }
                }
                this.searching = false;
              },
            },
          });
        }
      }); */
    },
    userInfo(uuid) {
      /* this.$router.replace({
        path: '/main-menu/user-info',
        query: { uuid },
      }); */
    },
    onAdd() {
      this.$router.replace({
        path: '/add-or-edit-project',
        query: {},
      });
    },
    onDelete() {
      console.log('Delete');
    },
  },
};
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
